const baseClassName = 'fi-icon';
const cursorPointerClassName = `${baseClassName}--cursor-pointer`;

export { baseClassName, cursorPointerClassName };
//# sourceMappingURL=classes.js.map
